import Model from "../../classes/model/Model";
import User from "./User";
import qs from "qs";
import Direction from "./Direction";
import Client from "./Client";
import Schedule from "./Schedule";
import Room from "./Room";
import Trainer from "./Trainer";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {int} company_id
 * @property {int} filiation_id
 * @property {int} schedule_id
 * @property {int} group_id
 * @property {int} room_id
 * @property {int} client_id
 * @property {int} direction_id
 * @property {int} trainer_id
 * @property {int} subscription_id
 * @property {int} subscription_client_id
 * @property {int} is_reservation
 * @property {string} date
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Client} client
 * @property {Direction} direction
 * @property {Room} room
 * @property {Schedule} schedule
 * @property {Trainer} trainer
 * @property {User} creator
 * @property {User} updater
 */
export default class Visit extends Model {

    get fullName() {
        let pieces = [];
        if (this.first_name) {
            pieces.push(this.first_name);
        }
        if (this.last_name) {
            pieces.push(this.last_name);
        }
        return pieces.join(' ');
    }

    relations() {
        return {
            client: {class: Client, many: false},
            direction: {class: Direction, many: false},
            room: {class: Room, many: false},
            schedule: {class: Schedule, many: false},
            trainer: {class: Trainer, many: false},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Visit.getAxios().get(Visit.getUrl('visit/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let trainer of response.data) {
                data.push(new Visit(trainer));
            }
            return {data, headers: response.headers};
        });
    }

    remove() {
        if (!this.id) {
            throw new Error('id not set');
        }

        return Visit.getAxios().post(Visit.getUrl('visit/remove'), {
            id: this.id,
        }).then(({data}) => {
            return data.success;
        });
    }

}
